import React, { useState } from "react";
import emailjs from "emailjs-com";

function ContactForm({
  placeHolder_nombre,
  placeHolder_telefono,
  placeHolder_correo,
  placeHolder_mensaje,
  placeHolder_btn,
}) {
  const [showModal, setShowModal] = useState(false);
  const ServiceID = "service_lqx25wr"; //ServiceId de Servicio de EmailJS
  const PublicKey = "t_EbnZvK0iT3WPIis"; //Llave publica de la api
  const cliente = "Cliente"; //Template del correo del cliente (el que recibe el correo)
  const usuario = "Usuario"; //Template que recibe el administrador
  const EmailToSend = "contacto@seguridadbp.com"; //Correo con el que se envia la informacion.

  const [toSend, setToSend] = useState({
    from_name: "",
    phone: "",
    reply_to: "",
    message: "",
  });
  const [errors, setErrors] = useState({
    from_name: "",
    phone: "",
    reply_to: "",
    message: "",
  });

  const handleCloseModal = () => setShowModal(false);
  const handleOpenModal = () => setShowModal(true);

  const handleSubmit = (e) => {
    e.preventDefault();

    const newErrors = {};
    if (!toSend.from_name.trim()) newErrors.from_name = "Por favor, escriba su nombre.";
    if (!toSend.message.trim()) newErrors.message = "Por favor ingrese un mensaje.";
    if (!validateEmail(toSend.reply_to))
      newErrors.reply_to = "Por favor, introduce una dirección de correo electrónico válida.";
    if (toSend.phone.trim().length !== 10 || isNaN(toSend.phone.trim()))
      newErrors.phone = "Ingrese un número de teléfono válido (10 dígitos).";

    if (Object.values(newErrors).some((error) => error)) {
      setErrors(newErrors);
      return;
    }
console.log(errors);
    emailjs
      .send(ServiceID, cliente, toSend, PublicKey)
      .then(() => {
        emailjs
          .send(
            ServiceID,
            usuario,
            { ...toSend, to_email: EmailToSend },
            PublicKey
          )
          .then(() => {
            handleOpenModal();
            setToSend({ from_name: "", phone: "", reply_to: "", message: "" });
          })
          .catch(console.error);
      })
      .catch(console.error);
  };

  const handleChange = (e) => {
    setToSend({ ...toSend, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);

  return (
    <>
      <form onSubmit={handleSubmit} className="">
        <div className="mb-4">
          <input
            type="text"
            placeholder={placeHolder_nombre}
            name="from_name"
            value={toSend.from_name}
            onChange={handleChange}
            className="w-full p-3 border-2 border-gray-300 rounded-md focus:outline-none focus:border-red-600 transition"
          />
          <p className="text-red-600 text-sm">{errors.from_name}</p>
        </div>
        <div className="mb-4">
          <input
            type="number"
            placeholder={placeHolder_telefono}
            maxLength={10}
            name="phone"
            value={toSend.phone}
            onChange={handleChange}
            className="w-full p-3 border-2 border-gray-300 rounded-md focus:outline-none focus:border-red-600 transition"
          />
          <p className="text-red-600 text-sm">{errors.phone}</p>
        </div>
        <div className="mb-4">
          <input
            type="email"
            placeholder={placeHolder_correo}
            name="reply_to"
            value={toSend.reply_to}
            onChange={handleChange}
            className="w-full p-3 border-2 border-gray-300 rounded-md focus:outline-none focus:border-red-600 transition"
          />
          <p className="text-red-600 text-sm">{errors.reply_to}</p>
        </div>
        <div className="mb-4">
          <textarea
            placeholder={placeHolder_mensaje}
            name="message"
            value={toSend.message}
            onChange={handleChange}
            className="w-full p-3 border-2 border-gray-300 rounded-md focus:outline-none focus:border-red-600 transition h-32"
          ></textarea>
          <p className="text-red-600 text-sm">{errors.message}</p>
        </div>

        <div className="mb-4 flex justify-center">
          <button
            type="submit"
            className="w-full items-center py-3 text-xl border border-red-600  font-semibold rounded-lg hover:-translate-y-2 bg-red-600 text-white transition-all duration-300 shadow-lg"
          >
            {placeHolder_btn}
          </button>
        </div>
      </form>
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center">
            <h2 className="text-lg font-semibold text-gray-800">
              ✅ Correo enviado correctamente
            </h2>
            <p className="mt-2 text-gray-700">
              ¡Muchas gracias por tu preferencia! Alguien de nuestro equipo se comunicará contigo en breve.
            </p>
            <button
              onClick={handleCloseModal}
              className="mt-4 bg-green-600 text-white px-4 py-2 rounded-md transition hover:bg-green-500"
            >
              Entiendo
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default ContactForm;
